// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconCard.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconCard = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 15 16" fill="currentColor" { ...props }>
    <path d="M8.98712 4.05176V0.247059C8.98712 0.123529 8.88686 0 8.73647 0H0.250651C0.125325 0 0 0.0988235 0 0.247059V11.0435C0 11.1671 0.10026 11.2906 0.250651 11.2906H4.07437V4.76824C4.07437 4.37294 4.40021 4.05176 4.80125 4.05176H8.98712Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M5.77874 5.53846H13.9136C14.0337 5.53846 14.1298 5.63553 14.1538 5.75687V15.7573C14.1538 15.9029 14.0337 16 13.9136 16H5.77874C5.63457 16 5.53846 15.8787 5.53846 15.7573V5.78114C5.53846 5.63553 5.6586 5.53846 5.77874 5.53846ZM6.94086 6.76923H12.7514C12.8373 6.76923 12.9059 6.84346 12.9231 6.93625V14.5837C12.9231 14.695 12.8373 14.7692 12.7514 14.7692H6.94086C6.83788 14.7692 6.76923 14.6764 6.76923 14.5837V6.95481C6.76923 6.84346 6.85505 6.76923 6.94086 6.76923Z" />
  </BaseIcon>
);

export default IconCard;
